import { Component } from 'react';
import PropTypes from "prop-types";

export default class CountDown extends Component{

  static propTypes = {
    tickTime: PropTypes.number.isRequired, // ”倒计时秒数A“，示例：14400
    onTimeEnd: PropTypes.func.isRequired, // ”倒计时秒数A“结束回调函数
    hasPreTime: PropTypes.bool, // 是否有”倒计时结束前秒数B“
    preTime: PropTypes.number, // ”倒计时结束前秒数B“，示例：倒计时结束前2小时内,7200=2*60*60
    onPreTime: PropTypes.func, // ”倒计时结束前秒数B“结束回调函数
    renderTime: PropTypes.func.isRequired, // 渲染组件函数
  }

  static defaultProps = {
    hasPreTime: false,
    preTime: 0,
    onPreTime: () => {},
  }

  constructor(props) {
    super(props);
    const { tickTime } = this.props;
    const __tickTime = Date.parse(new Date()) / 1000 + tickTime;
    window.sessionStorage.setItem('__tickTime', __tickTime);
    this.Timer = null;
    this.hasCallPreTime = false;
  }

  state = {
    day: '0',
    hour: '00',
    minute: '00',
    second: '00',
  };

  componentDidMount() {
    this.getTime();
  }

  componentWillUnmount() {
    clearTimeout(this.Timer);
  }

  getTime = () => {
    const storageTime = window.sessionStorage.getItem('__tickTime');
    let __tickTime = storageTime - Date.parse(new Date()) / 1000;

    if (__tickTime <= 0) {
      __tickTime = 0;
      this.props.onTimeEnd();
      clearTimeout(this.Timer);
    }

    const day = Math.floor(__tickTime / 86400);
    const hour = Math.floor((__tickTime % 86400 ) / 3600);
    const minute = Math.floor(((__tickTime % 86400 ) % 3600 ) / 60);
    const second = ((__tickTime % 86400) % 3600) % 60;

    this.setState({
      day: day,
      hour: hour < 10 ? '0' + hour : hour,
      minute: minute < 10 ? '0' + minute : minute,
      second: second < 10 ? '0' + second : second
    }, () => {
      const { hasPreTime = false, preTime, onPreTime } = this.props;
      this.Timer = setTimeout(() => {
        if (hasPreTime && __tickTime - 1 <= preTime && !this.hasCallPreTime) {
          this.hasCallPreTime = true;
          onPreTime && onPreTime()
        }
        if (__tickTime > 0) {
          this.getTime()
        }
      }, 1000);
    });
  }

  render() {
    const { renderTime } = this.props;
    const { day, hour, minute, second } = this.state;

    return renderTime({ day, hour, minute, second });
  }
}
